import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

/**
 * Coordinates the mobile global-search overlay between the persistent footer
 * action and the opt-in mobile top navigation shell.
 */
@Injectable({providedIn: 'root'})
export class MobileSearchOverlayService {
  private readonly openSubject = new BehaviorSubject(false);

  public readonly open$ = this.openSubject.asObservable();

  public open(): void {
    this.openSubject.next(true);
  }

  public close(): void {
    this.openSubject.next(false);
  }
}
